export default __webpack_public_path__ + "static/media/713.43a94394.gif";